// hooks/useSeo.js
import { useEffect } from "react";

const SITE_URL = "https://www.crownedroofing.com";

export default function useSeo({
  title,
  description,
  ogImage,
  canonical,
}) {
  useEffect(() => {
    /* ---------- TITLE ---------- */
    if (title) document.title = title;

    /* ---------- DESCRIPTION ---------- */
    if (description) {
      let meta = document.querySelector("meta[name='description']");
      if (!meta) {
        meta = document.createElement("meta");
        meta.setAttribute("name", "description");
        document.head.appendChild(meta);
      }
      meta.setAttribute("content", description);
    }

    /* ---------- CANONICAL ---------- */
    const canon =
      canonical || SITE_URL + window.location.pathname;

    let link = document.querySelector("link[rel='canonical']");
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", canon);

    /* ---------- OG ---------- */
    setOg("og:title", title);
    setOg("og:description", description);
    setOg("og:image", ogImage);
    setOg("og:url", canon);
  }, [title, description, ogImage, canonical]);
}

function setOg(property, content) {
  if (!content) return;

  let tag = document.querySelector(
    `meta[property='${property}']`
  );
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute("property", property);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
}
